   <template>
  <div class="vue-feedback-reaction" :style="containerStyle">
    <div
      class="reaction"
      v-for="item in reactions"
      :key="item.id"
      @mouseenter="hovering = item.id"
      @mouseleave="hovering = null"
      @click="select(item.id)"
      role="button"
      :aria-pressed="String(modelValueLocal) === item.id"
      tabindex="0"
      @keydown.enter.prevent="select(item.id)"
      @keydown.space.prevent="select(item.id)"
    >
      <img
        :src="currentImage(item)"
        :style="emojiStyle"
        :alt="item.id"
        class="emoji-img"
      />
      <span v-if="labels && labels.length" :class="labelClass">
        {{ labels[Number(item.id) - 1] || '' }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import Good from 'vue-feedback-reaction/src/assets/img/good.gif'
import Hate from 'vue-feedback-reaction/src/assets/img/hate.gif'
import Natural from 'vue-feedback-reaction/src/assets/img/natural.gif'
import Excellent from 'vue-feedback-reaction/src/assets/img/excellent.gif'
import Disappointed from 'vue-feedback-reaction/src/assets/img/disappointed.gif'
import GoodInactive from 'vue-feedback-reaction/src/assets/img/good_inactive.png'
import HateInactive from 'vue-feedback-reaction/src/assets/img/hate_inactive.png'
import NaturalInactive from 'vue-feedback-reaction/src/assets/img/natural_inactive.png'
import ExcellentInactive from 'vue-feedback-reaction/src/assets/img/excellent_inactive.png'
import DisappointedInactive from 'vue-feedback-reaction/src/assets/img/disappointed_inactive.png'
import GoodActive from 'vue-feedback-reaction/src/assets/img/good_active.png'
import HateActive from 'vue-feedback-reaction/src/assets/img/hate_active.png'
import NaturalActive from 'vue-feedback-reaction/src/assets/img/natural_active.png'
import ExcellentActive from 'vue-feedback-reaction/src/assets/img/excellent_active.png'
import DisappointedActive from 'vue-feedback-reaction/src/assets/img/disappointed_active.png'

/* global defineProps, defineEmits */
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  labels: {
    type: Array,
    default: () => []
  },
  labelClass: {
    type: [Object, Array, String],
    default: ''
  },
  emojiWidth: {
    type: [String, Number],
    default: ''
  },
  emojiHeight: {
    type: [String, Number],
    default: ''
  },
  containerWidth: {
    type: [String, Number],
    default: ''
  },
  containerHeight: {
    type: [String, Number],
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const modelValueLocal = ref(props.modelValue || '')
watch(() => props.modelValue, (val) => {
  modelValueLocal.value = val || ''
})

const reactions = [
  { id: '1', hover: Hate, inactive: HateInactive, active: HateActive },
  { id: '2', hover: Disappointed, inactive: DisappointedInactive, active: DisappointedActive },
  { id: '3', hover: Natural, inactive: NaturalInactive, active: NaturalActive },
  { id: '4', hover: Good, inactive: GoodInactive, active: GoodActive },
  { id: '5', hover: Excellent, inactive: ExcellentInactive, active: ExcellentActive }
]

const hovering = ref(null)

const formatSize = (v) => {
  if (v === null || v === undefined || v === '') return ''
  return typeof v === 'number' ? `${v}px` : v
}

const emojiStyle = computed(() => ({
  width: formatSize(props.emojiWidth) || '52px',
  height: formatSize(props.emojiHeight) || '52px'
}))

const containerStyle = computed(() => ({
  width: formatSize(props.containerWidth) || '100%',
  height: formatSize(props.containerHeight) || 'auto'
}))

const currentImage = (item) => {
  if (String(modelValueLocal.value) === item.id) return item.hover
  if (hovering.value === item.id) return item.hover
  return item.inactive
}

function select(id) {
  modelValueLocal.value = id
  emit('update:modelValue', id)
}
</script>

<style scoped>
.vue-feedback-reaction {
  margin: 10px auto;
  padding: 0;
  text-align: center;
  display: inline-flex;
}
.reaction {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all .2s ease;
  margin: 0 auto;
  padding: 0 8px;
  cursor: pointer;
}
.reaction:focus-within,
.reaction:hover {
  transform: translateY(-4px) scale(1.03);
}
.emoji-img {
  display: block;
}
</style>
